import { TemplateWrapperProps } from 'common'

export function TemplateWrapper(props: TemplateWrapperProps) {
  return (
    <div {...props} id="wrapper">
      {props.children}
    </div>
  )
}
